<nb-card>
  <nb-card-header>
    <h3>
      Upcoming Tasks
    </h3>
  </nb-card-header>
  <nb-card-body>
    <div class="row">
      <div class="col">
        <div class="m-timeline-3">
          <div class="m-timeline-3__items">
            <div *ngFor="let task of fieldTasks">
              <div class="m-timeline-3__item " [class.m-timeline-3__item--info]="task.dateDifference > 0"
                [class.m-timeline-3__item--danger]="task.dateDifference < 0"
                [class.m-timeline-3__item--warning]="task.dateDifference === 0">
                <span class="m-timeline-3__item-time">{{ task.dateDifference }} <div style="font-size: 10px;">Days</div>
                  </span>
                <div class="m-timeline-3__item-desc">
                  <span class="m-timeline-3__item-text">
                    {{task.requestedFieldEventType.name}}
                    <i class="fas {{task.requestedFieldEventType.fontAwesomeIconName}} fa-sm"
                      [ngStyle]="{'color': task.requestedFieldEventType.iconColor}"></i>
                  </span><br>
                  <span class="m-timeline-3__item-user-name">
                    <a href="#" class="m-link m-link--metal m-timeline-3__item-link">
                      {{task.assignedUserLabel}}
                    </a>
                  </span><br>
                  <span class="m-timeline-3__item-user-name">
                    <a href="#" class="m-link m-link--metal m-timeline-3__item-link">
                      0 Events logged
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nb-card-body>
</nb-card>
